import { render, staticRenderFns } from "./SwitchSingle.vue?vue&type=template&id=0799ee31&scoped=true&"
import script from "./SwitchSingle.vue?vue&type=script&lang=js&"
export * from "./SwitchSingle.vue?vue&type=script&lang=js&"
import style0 from "./SwitchSingle.vue?vue&type=style&index=0&id=0799ee31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799ee31",
  null
  
)

export default component.exports